import React, { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { BASE_URL, ENABLE_LOGIN_DEVTOOLS } from '../../utilities/constants'

import { Button, Loader } from '../../components/transpais'
import { useModal } from '../../contexts/modal.context'
import { useNavigate } from 'react-router-dom'
import { useLogger } from '../../contexts/logger.context'

import '../../scss/Layout.scss'
import * as Styled from './Login.styled'

import gateway from '../../services/gateway'
import { useAtom } from 'jotai'
import {
  claveUsuario,
  usuarioID,
  puntoVentaID,
  estacionID,
  accessToken,
  nombrePuntoVenta,
  TranspaisIDToken,
  Credentials,
  originDefault,
} from '../../utilities/atoms'
import { usePinpad } from '../../contexts/pinpad.context'
import Footer from './components/Footer'
import transpaisid from '../../services/transpaisid'
import transpais from '../../services/transpais'
import jwt_decode from "jwt-decode"

import { handleApiError, reportError } from '../../helpers/errorHandler'
import { ensureElectronPinpadReady } from '../../helpers/electronPinpadCredentials'
import { getPinpadFlowId, logFlowStep, startPinpadFlow } from '../../utilities/pinpad-v2/flow-logger'
import { isValidTranspaisJwtShape } from '../../utilities/token'
import { ensureLocalBookingStubFromAccessToken, isLocalBookingApiEnabled } from '../../helpers/localBookingApi'

const Login = () => {
  const {loggerDebug, loggerError} = useLogger()
  const {loading} = usePinpad()
  const navigate = useNavigate()

  const [localLoading, setLocalLoading] = useState(false)

  const {showModal, setupModal} = useModal()

  const [canContinue, setCanContinue] = useState(false)

  const [mac, setMac] = useState('')
  const [user, setUser] = useState('')
  const [pass, setPass] = useState('')
  const [userID, setUserID] = useState('')
  const [passUserId, setPassUserId] = useState('')

  const [cveUsuario, setCveUsuario] = useAtom(claveUsuario)
  const [usuarioId, setUsuarioId] = useAtom(usuarioID)
  const [puntoVentaId, setPuntoVentaId] = useAtom(puntoVentaID)
  const [estacionId, setEstacionId] = useAtom(estacionID)
  const [token, setToken] = useAtom(accessToken)
  const [transpaisIDToken, setTranspaisIDToken] = useAtom(TranspaisIDToken)
  const [nombPuntoVenta, setNombPuntoVenta] = useAtom(nombrePuntoVenta)
  const [credentials, setCredentials] = useAtom(Credentials)
  const [origins, setOrigins] = useState(null)
  const [originSelected, setOriginSelected] = useAtom(originDefault)
  const [canToggleDevTools, setCanToggleDevTools] = useState(false)

  useEffect(() => {
    setCanToggleDevTools(
      ENABLE_LOGIN_DEVTOOLS &&
      typeof window !== 'undefined' &&
      typeof window.electronAPI?.toggleDevTools === 'function'
    )
  }, [])

  const toggleDevTools = async () => {
    try {
      await window.electronAPI.toggleDevTools()
    } catch (error) {
      console.warn('[Login] No se pudo abrir DevTools', error)
    }
  }

  const loadOrigins = async () => {
    setLocalLoading(true)
    try {
      const response = await transpais.origins()
      setOrigins(response.data.origins)
    } catch (error) {
      const { userMessage, errorData } = handleApiError(error, { action: 'loadOrigins' })
      reportError(error, errorData)
      console.error('Error cargando orígenes:', userMessage)
    } finally {
      setLocalLoading(false)
    }
  }

  useEffect(() => {
    console.log('localLoading: ', localLoading)
    console.log('loading: ', loading)
    if (userID.trim() !== '' && passUserId.trim() !== '' && originSelected !== '') {
      setCanContinue(true)
    } else {
      setCanContinue(false)
    }
  }, [userID, passUserId,originSelected])

  useEffect(() => {
    loggerDebug('check')
    loggerDebug(transpaisIDToken)
    if (transpaisIDToken.trim() !== '') {
      loggerDebug('redirect')
      setLocalLoading(false)
      navigate(`${ BASE_URL }/`)
    }
  }, [transpaisIDToken])

  useEffect(() => {
    loadOrigins()
  }, [])

  const login = () => {
    setLocalLoading(true)
    loggerDebug(mac, user, pass)
    gateway
      .login(mac, user, pass)
      .then((response) => {
        loggerDebug(response.data)
        const data = response.data

        loggerDebug(data)

        setCveUsuario(data.cveUsuario)
        setUsuarioId(data.usuario_id)
        setPuntoVentaId(data.puntoVenta_id)
        setEstacionId(data.estacion_id)
        setToken(data.token)
        setNombPuntoVenta(data.nombPuntoVenta)

        Sentry.setUser({
          id: data.usuario_id,
          username: data.cveUsuario,
          pos_id: data.puntoVenta_id,
          pos: data.nombPuntoVenta,
        })
      })
      .catch(error => {
        loggerError(error)
        const data = error.response.data
        loggerError(data)

        setLocalLoading(false)
        setupModal({
          title: 'Atención',
          content: (<><p>{ data.error }</p></>),
        })
        showModal()
      })
  }

  const signin = () => {
    setLocalLoading(true)
  
    // Llamar al servicio de inicio de sesión
    transpaisid.signIn(userID, passUserId)
      .then(async (response) => {
        const accessToken = response.data.access_token
        if (!isValidTranspaisJwtShape(accessToken)) {
          setLocalLoading(false)
          setupModal({
            title: 'Atención',
            content: (<><p>La sesión recibida no es válida. Intenta de nuevo o contacta a soporte.</p></>),
          })
          showModal()
          return
        }
        let decodedToken
        try {
          decodedToken = jwt_decode(accessToken)
        } catch (e) {
          loggerError('Token de invitado ilegible tras signIn', e)
          setLocalLoading(false)
          setupModal({
            title: 'Atención',
            content: (<><p>No se pudo validar la sesión. Intenta de nuevo.</p></>),
          })
          showModal()
          return
        }

        if (isLocalBookingApiEnabled()) {
          try {
            await ensureLocalBookingStubFromAccessToken(accessToken, jwt_decode)
          } catch (stubError) {
            loggerError('No se pudo preparar auth local de booking API', stubError)
            setLocalLoading(false)
            setupModal({
              title: 'Atención',
              content: (<><p>No se pudo conectar con la API local de booking. Revisa REACT_APP_USE_LOCAL_BOOKING_API.</p></>),
            })
            showModal()
            return
          }
        }

        setTranspaisIDToken(accessToken)
        const pin = decodedToken.sub
  
        // Configurar el contexto de Sentry
        Sentry.setContext('signupGuest', {
          email: userID,
        })
  
        // Llamar al servicio credentials con el token obtenido
        return transpais.credentials(accessToken).then(async (response) => {
          // Configurar el contexto de Sentry con los datos de credentials
          Sentry.setContext('Trip', {
            name: response.data.name,
            value: response.data.value,
          })
  
          // Guardar las credenciales en el estado, incluyendo el `pin`
          const creds = {
            name: response.data.name,
            value: response.data.value,
            pin: pin,
          }
          setCredentials(creds)

          const ensured = await ensureElectronPinpadReady(creds)
          if (!ensured.ok && !ensured.skipped && typeof window !== 'undefined' && window.electronAPI?.getPinpadStatus) {
            console.warn('[ELECTRON AUTH] Pinpad Electron no autenticado tras login', ensured.status)
          }
  
          setLocalLoading(false)
        })
      })
      .catch((error) => {
        console.error('Error en signin o credentials:', error)
  
        // Manejar errores
        const data = error.response?.data || { message: 'Error desconocido' }
        setLocalLoading(false)
        setupModal({
          title: 'Atención',
          content: (<><p>{data.message}</p></>),
        })
        showModal()
      })
  }

  // DEBUG ONLY: delega compra de prueba a Electron (IPC).
  const startPinpadStepByStep = async () => {
    const flowId = startPinpadFlow({ trigger: 'login-test-button' })
    const manualStartTime = Date.now()

    logFlowStep({
      phase: 'INIT',
      step: 'Button startPinpadStepByStep clicked (Login)',
      stepNumber: 1,
      status: 'START',
      data: { flowId },
    })

    try {
      const testReference = `TEST-${Math.random().toString(36).slice(2, 10).toUpperCase()}`
      const testAmount = 10000 // $100.00 MXN

      logFlowStep({
        phase: 'PURCHASE',
        step: 'Starting test purchase (Login)',
        stepNumber: 13,
        status: 'START',
        data: {
          reference: testReference,
          amount: testAmount,
          amountFormatted: `$${(testAmount / 100).toFixed(2)} MXN`,
        },
      })

      logFlowStep({
        phase: 'ELECTRON_SEND',
        step: 'ELECTRON_SEND: Sending test purchase to Electron (Login)',
        stepNumber: 14,
        status: 'START',
        data: { reference: testReference, amount: testAmount },
      })

      if (!window.electronAPI || typeof window.electronAPI.testPurchase !== 'function') {
        const missingApiError = new Error('electronAPI.testPurchase is not available (no preload bridge)')
        missingApiError.code = 'ELECTRON_API_NOT_AVAILABLE'
        throw missingApiError
      }

      logFlowStep({
        phase: 'ELECTRON_WAIT',
        step: 'ELECTRON_WAIT: Awaiting electronAPI.testPurchase (invoke/handle) (Login)',
        stepNumber: 15,
        status: 'START',
        data: { reference: testReference },
      })

      const electronResponse = await window.electronAPI.testPurchase({
        reference: testReference,
        amount: testAmount,
      })

      if (!electronResponse?.ok || !electronResponse?.charge) {
        const rpcError = new Error(electronResponse?.error || 'Electron testPurchase returned no charge')
        rpcError.code = electronResponse?.code || 'ELECTRON_TEST_PURCHASE_FAILED'
        throw rpcError
      }

      const purchaseResult = {
        success: true,
        charge: electronResponse.charge,
        voucherPrinted: electronResponse.voucherPrinted,
        voucherPrintError: electronResponse.voucherPrintError,
      }

      logFlowStep({
        phase: 'COMPLETE',
        step: 'Test purchase completed (Login)',
        stepNumber: 23,
        status: 'SUCCESS',
        duration: Date.now() - manualStartTime,
        data: {
          reference: testReference,
          foliocpagos: purchaseResult?.charge?.foliocpagos,
          auth: purchaseResult?.charge?.auth,
          amount: purchaseResult?.charge?.amount,
        },
      })

      setupModal({
        title: '✅ Compra Exitosa',
        content: (
          <>
            <p><strong>Referencia:</strong> {testReference}</p>
            <p><strong>Folio:</strong> {purchaseResult?.charge?.foliocpagos}</p>
            <p><strong>Autorización:</strong> {purchaseResult?.charge?.auth}</p>
            <p><strong>Monto:</strong> ${(testAmount / 100).toFixed(2)} MXN</p>
            <p><strong>Tarjeta:</strong> {purchaseResult?.charge?.cc_number}</p>
            <p><strong>Tipo:</strong> {purchaseResult?.charge?.cc_type}</p>
            <p><strong>Voucher cliente:</strong> {purchaseResult?.voucherPrinted ? 'Impreso ✅' : 'No impreso ⚠️'}</p>
            {!purchaseResult?.voucherPrinted && purchaseResult?.voucherPrintError ? (
              <p><strong>Detalle impresión:</strong> {purchaseResult?.voucherPrintError}</p>
            ) : null}
          </>
        ),
        actions: {
          positive: {
            title: 'Cerrar',
            onClick: () => {},
          },
        },
      })
      showModal()
    } catch (error) {
      logFlowStep({
        phase: 'ERROR',
        step: 'Test flow failed (Login)',
        stepNumber: 24,
        status: 'ERROR',
        error: {
          code: error?.code || 'UNKNOWN',
          message: error?.message,
          stack: error?.stack,
          flowId: getPinpadFlowId(),
        },
      })
      loggerError('Error en test de PinPad (Login)', error)

      setupModal({
        title: '❌ Error en Compra',
        content: (
          <>
            <p><strong>Código:</strong> {error?.code || 'UNKNOWN'}</p>
            <p><strong>Mensaje:</strong> {error?.message || 'Error desconocido'}</p>
          </>
        ),
        actions: {
          positive: {
            title: 'Cerrar',
            onClick: () => {},
          },
        },
      })
      showModal()
    }
  }

  // const signin = () => {
  //   transpaisid.signIn(userID, passUserId)
  //     .then((response) => {
  //       console.log(response)
  //       setTranspaisIDToken(response.data.access_token)
  //       Sentry.setContext('signupGuest', {
  //         email: userID,
  //       })
        
  //     }).catch(error => {
  //       loggerError(error)
  //       const data = error.response.data
  //       console.log(error)
  //       loggerError(data)

  //       setLocalLoading(false)
  //       setupModal({
  //         title: 'Atención',
  //         content: (<><p>{ data.message }</p></>),
  //       })
  //       showModal()
  //     })

  //     transpais.credentials(transpaisIDToken)
  //     .then((response) => {
  //       console.log('response credentials', response)
  //       Sentry.setContext('Trip', {
  //         name: response.data.name,
  //         value: response.data.value,
  //       })
  //       setLocalLoading(false)
  //       const name = response.data.name
  //       const value = response.data.value
  //       setCredentials({
  //         name,
  //         value,
  //       })
  //     }).catch((error) => {
  //       console.log('error credentials', error)
  //     setLocalLoading(false)

  //   })
  // }

  return (
    <>
      <Loader show={ localLoading }/>
      {/*----Page----*/ }
      <Styled.Page className={ ['section-full'].join(' ') }>
        <Styled.Content className={ ['section-flex'].join(' ') }>
          <Styled.Top className={ ['logo'].join(' ') }>
            <figure className={ ['logo-image', 'logo-image-transpais-dark'].join(' ') }/>
          </Styled.Top>
          <Styled.LoginForm>
            <Styled.Card>
              <h1>Configuración de kiosco</h1>
              <Styled.FieldGroup>
                <label>Origen default</label>
                <select
                  value={originSelected}
                  onChange={ e => {
                      setOriginSelected(e.target.value)
                    }
                  }
                >
                  <option value="">Selecciona un origen</option>
                  { origins && origins.map((origin) => (
                    <option key={ origin._id } value={ origin._id }>
                      { origin.displayName }
                    </option>
                  )) }
                </select>
              </Styled.FieldGroup>
              <Styled.FieldGroupContent>
                <Styled.FieldGroup>
                  <label>Transpais ID</label>
                  <input type="text" value={ userID } onChange={ e => setUserID(e.target.value) }/>
                </Styled.FieldGroup>
                <Styled.FieldGroup>
                  <label>Contraseña Transpais ID</label>
                  <input type="password" value={ passUserId } onChange={ e => setPassUserId(e.target.value) }/>
                </Styled.FieldGroup>
              </Styled.FieldGroupContent>
              
              <Button
                type="positive"
                disabled={ !canContinue }
                onClick={ signin }
              >
                Iniciar
              </Button>

              {/*<button type="button" onClick={ startPinpadStepByStep }>test</button>*/}
            </Styled.Card>
          </Styled.LoginForm>
          <Footer/>
          {canToggleDevTools && (
            <Styled.DevToolsToggle
              type="button"
              aria-label="Abrir herramientas de desarrollo"
              onClick={ toggleDevTools }
            >
              dev
            </Styled.DevToolsToggle>
          )}
        </Styled.Content>
        <Styled.Background>
          <Styled.BackgroundImage/>
        </Styled.Background>
      </Styled.Page>
    </>
  )
}

export default Login